import React, { useContext, useEffect } from "react";

const ProductContext = React.createContext();
export function useProductContext() {
  return useContext(ProductContext);
}

export default function ProductProvider({ children }) {
  const MAXIMUM_QUANTITY = 5;
  const products = [
    {
      bestseller: "true",
      group: "cleansing",
      productId: "prod_L0ydT6J1tc5YaN",
      title: "Premium All-Purpose Wipes",
      subtitle: "Premium All-Purpose Wipes subtitle",
      price_US: 8.99,
      price_KO: 7120,
      priceId: "price_1KKwg1GL7n6A7ptgtmKngwNo",
      linkTo: "all-purpose-wipe",
      img: "/img/heslet-all-purpose.jpeg",
      imgs: [
        {
          image: "/img/heslet-all-purpose.jpeg",
        },
        {
          image: "/img/Flushable-Wipe.png",
        },
        {
          video: "https://www.youtube.com/embed/-A-5ajlS79w",
          thumbnail: "http://i3.ytimg.com/vi/-A-5ajlS79w/hqdefault.jpg",
        },
      ],
      volumn: "500ml",
      list: [
        {
          menu: "DETAILS",
          details: [
            "Effectively Eliminates Tough Grime at Once (Magic Clean)",
            "Kills 99.9% of Germs in as little as 60 Seconds",
            "7 Days of Long-Lasting Anti-Bacterial Protection ",
            "99.9% Deodorization Effect within 30 Minutes ",
            "Nano-Colloidal Platinum for Skin Moisturization",
            "Fresh Citrus Scent: Extracted from Natural Oranges",
            "Oval Canister for Easy-Grip ",
            "Two-Way Stretch Fabric ",
          ],
        },
        {
          menu: "INGREDIENTS",
          details: [
            "100% Non Alcohol",
            "Free of Ethanol, Benzalkonium, and Isopropanol",
          ],
        },
        {
          menu: "CUSTOMER'S BENEFIT",
          details: [
            "Protect Respiratory System and Hand Skin from Hazardous Chemicals",
          ],
        },
        {
          menu: "ENVIRONMENT",
          details: [
            "Eco-friendly Biodegradable Non-Woven Fabric for the Environment",
          ],
        },
        {
          menu: "CERTIFICATION",
          details: ["FDA Medical Class 1 (Registered No.3021006214)"],
        },
        { menu: "LOCATION", details: ["Made in Korea"] },
      ],
      icon: ["plant", "no-bacteria", "korea"],
    },

    {
      bestseller: "true",
      group: "cleansing",
      productId: "prod_L3e4fNWKRAKHAv",
      title: "Premium All-Purpose Spray",
      subtitle: "Premium All-Purpose Spray subtitle",
      price_US: 8.99,
      price_KO: 7120,
      priceId: "price_1KP93YGL7n6A7ptgetVXCCCp",
      linkTo: "all-purpose-spray",
      img: "/img/heslet-perfect-all-clean.jpeg",
      imgs: [
        {
          image: "/img/heslet-perfect-all-clean.jpeg",
        },
        {
          image: "/img/All-Purpose-Spray.png",
        },
        {
          video: "https://www.youtube.com/embed/-A-5ajlS79w",
          thumbnail: "http://i3.ytimg.com/vi/-A-5ajlS79w/hqdefault.jpg",
        },
        {
          video: "https://www.youtube.com/embed/-A-5ajlS79w",
          thumbnail: "http://i3.ytimg.com/vi/-A-5ajlS79w/hqdefault.jpg",
        },
      ],
      volumn: "500ml",
      list: [
        {
          menu: "DETAILS",
          details: [
            "Effectively Eliminates Tough Grime at Once (Magic Clean)",
            "Kills 99.9% of Germs in as little as 60 Seconds",
            "7 Days of Long-Lasting Anti-Bacterial Protection ",
            "99.9% Deodorization Effect within 30 Minutes ",
            "Fresh Citrus Scent: Extracted from Natural Oranges",
          ],
        },
        {
          menu: "INGREDIENTS",
          details: [
            "100% Non Alcohol",
            "Free of Ethanol, Benzalkonium, and Isopropanol",
          ],
        },
        {
          menu: "CUSTOMER'S BENEFIT",
          details: [
            "Protect Respiratory System and Hand Skin from Hazardous Chemicals",
          ],
        },
        {
          menu: "ENVIRONMENT",
          details: ["No Harmful Chemicals"],
        },
        {
          menu: "CERTIFICATION",
          details: ["FDA Medical Class 1 (Registered No.3021006214)"],
        },
        { menu: "LOCATION", details: ["Made in Korea"] },
      ],
      icon: ["plant", "no-bacteria", "korea"],
    },
    {
      group: "pet",
      productId: "prod_L87lCnUUuPfoV8",
      title: "Premium Skin Care & Anti-Bacterial Spray for Dogs",
      subtitle: "Premium Skin Care & Anti-Bacterial Spray for Dogs subtitle",
      price_US: 20.99,
      price_KO: 19200,
      linkTo: "pet-spray",
      img: "/img/heslet-pet-spray.png",
      imgs: [
        {
          image: "/img/heslet-pet-spray.png",
        },
        {
          image: "/img/heslet-pet-spray.png",
        },
        {
          video: "https://www.youtube.com/embed/-A-5ajlS79w",
          thumbnail: "http://i3.ytimg.com/vi/-A-5ajlS79w/hqdefault.jpg",
        },
      ],
      volumn: "200ml",
      list: [
        {
          menu: "DETAILS",
          details: [
            "Colloidal Zinc Effective for Pet Skincare",
            "Kills 99.9% of Germs and Bacteria on Pet's Skin",
            "Strong Deodorization within 30 Minutes",
            "7 Days of Long-Lasting Anti-Bacterial Protection ",
            "Nano-Colloidal Platinum for Skin Moisturization",
            "Centella Asiatica Extract-Wound & Scar healing / Anti-inflammatory",
            "Solanum Tuberosum Pulp Extract-Antioxidant (Brightening & Soothing Effects)",
            "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
            "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
          ],
        },
        {
          menu: "INGREDIENTS",
          details: [
            "100% Non Alcohol",
            "Free of Ethanol, Benzalkonium, and Isopropanol",
          ],
        },
        {
          menu: "CUSTOMER'S BENEFIT",
          details: [
            "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
          ],
        },
        {
          menu: "ENVIRONMENT",
          details: ["No Harmful Toxins and Chemicals"],
        },
        {
          menu: "CERTIFICATION",
          details: ["FDA Medical Class 1 (Registered No.3021006214)"],
        },
        { menu: "LOCATION", details: ["Made in Korea"] },
      ],
      icon: ["plant", "no-bacteria", "korea"],
    },

    {
      group: "pet",
      productId: "prod_LQTlFUXuQGc9nl",
      title: "Premium Skin Care & Anti-Bacterial Wipe for Dogs",
      subtitle: "Premium Skin Care & Anti-Bacterial Wipe for Dogs subtitle",
      price_US: 5.99,
      price_KO: 4500,
      linkTo: "pet-tissue",
      img: "/img/heslet-pet-wipe.jpeg",
      imgs: [
        {
          image: "/img/heslet-pet-wipe.jpeg",
        },
        {
          image: "/img/heslet-pet-wipe.jpeg",
        },
        {
          video: "https://www.youtube.com/embed/-A-5ajlS79w",
          thumbnail: "http://i3.ytimg.com/vi/-A-5ajlS79w/hqdefault.jpg",
        },
      ],
      volumn: "200ml",
      list: [
        {
          menu: "DETAILS",
          details: [
            "Colloidal Zinc Effective for Pet Skincare",
            "Kills 99.9% of Germs and Bacteria on Pet's Skin",
            "Strong Deodorization within 30 Minutes",
            "7 Days of Long-Lasting Anti-Bacterial Protection ",
            "Nano-Colloidal Platinum for Skin Moisturization",
            "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
            "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
            "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
            "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
          ],
        },
        {
          menu: "INGREDIENTS",
          details: [
            "100% Non Alcohol",
            "Free of Ethanol, Benzalkonium, and Isopropanol",
          ],
        },
        {
          menu: "CUSTOMER'S BENEFIT",
          details: [
            "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
          ],
        },
        {
          menu: "ENVIRONMENT",
          details: ["No Harmful Toxins and Chemicals"],
        },
        {
          menu: "CERTIFICATION",
          details: ["FDA Medical Class 1 (Registered No.3021006214)"],
        },
        { menu: "LOCATION", details: ["Made in Korea"] },
      ],
      icon: ["plant", "no-bacteria", "korea"],
    },

    {
      group: "living",
      productId: "prod_LQUBQLWAq89tSv",
      title: "Shoe Cleaner Wipe",
      subtitle: "Shoe Cleaner Wipe subtitle",
      price_US: 69.99,
      price_KO: 68000,
      linkTo: "shoe-tissue",
      img: "/img/shoetotal.jpeg",
      imgs: [
        {
          image: "/img/shoetotal.jpeg",
        },
        {
          image: "/img/allpurpose.jpeg",
        },
        {
          image: "/img/shoetotal.jpeg",
        },

        {
          video: "https://www.youtube.com/embed/-A-5ajlS79w",
          thumbnail: "http://i3.ytimg.com/vi/-A-5ajlS79w/hqdefault.jpg",
        },
      ],
      volumn: "200ml",
      list: [
        {
          menu: "DETAILS",
          details: [
            "Colloidal Zinc Effective for Shoes",
            "Kills 99.9% of Germs and Bacteria on Shoes",
            "Strong Deodorization within 30 Minutes",
            "7 Days of Long-Lasting Anti-Bacterial Protection ",
            "Nano-Colloidal Platinum for Skin Moisturization",
            "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
            "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
            "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
            "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
          ],
        },
        {
          menu: "INGREDIENTS",
          details: [
            "100% Non Alcohol",
            "Free of Ethanol, Benzalkonium, and Isopropanol",
          ],
        },
        {
          menu: "CUSTOMER'S BENEFIT",
          details: [
            "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
          ],
        },
        {
          menu: "ENVIRONMENT",
          details: ["No Harmful Toxins and Chemicals"],
        },
        {
          menu: "CERTIFICATION",
          details: ["FDA Medical Class 1 (Registered No.3021006214)"],
        },
        { menu: "LOCATION", details: ["Made in Korea"] },
      ],
      icon: ["plant", "no-bacteria", "korea"],
    },
    {
      bestseller: "true",
      group: "living",
      productId: "prod_L0ydT6J1tc5Yaa",
      title: "Premium Heavy Duty Hand Wipes",
      subtitle: "Premium Heavy Duty Hand Wipes subtitle",
      price_US: 11.99,
      price_KO: 11200,
      linkTo: "heavy-duty-wipe",
      img: "/img/allpurpose.jpeg",
      imgs: [
        {
          image: "/img/allpurpose.jpeg",
        },
        {
          image: "/img/allpurpose.jpeg",
        },
      ],
      volumn: "120 pks",
      list: [
        {
          menu: "DETAILS",
          details: [
            "Effectively Eliminates Tough Messes While Camping ",
            "For Both Hands and equipment",
            "Kills 99.9% of Germs in as little as 60 Seconds",
            "7 Days of Long-Lasting Anti-Bacterial Protection ",
            "99.9% Deodorization Effect within 30 Minutes",
          ],
        },
        {
          menu: "INGREDIENTS",
          details: [
            "100% Non Alcohol",
            "Free of Ethanol, Benzalkonium, and Isopropanol",
          ],
        },
        {
          menu: "CUSTOMER'S BENEFIT",
          details: [
            "Disinfecting Wipes Combined with Nano Technology",
            "Perfect for Camping and Leisure",
          ],
        },
        {
          menu: "ENVIRONMENT",
          details: [
            "Eco-friendly Biodegradable Non-Woven Fabric for the Environment",
          ],
        },
        {
          menu: "CERTIFICATION",
          details: ["FDA Medical Class 1 Pending "],
        },
        { menu: "LOCATION", details: ["Made in Korea"] },
      ],
      icon: ["plant", "no-bacteria", "korea"],
    },

    // {
    //   group: "shoe",
    //   productId: "prod_LQUBQLWAq89tSv",
    //   title: "Shoe Cleaner Wipe",
    //   subtitle: "Kills 99.9% of Germs and Bacteria on Shoes",
    //   price_US: 12.99,
    //   price_KO: 3400,
    //   linkTo: "shoe-tissue",
    //   img: "/img/shoe-wipe.jpeg",
    //   imgs: [
    //     {
    //       image: "/img/shoe-wipe.jpeg",
    //     },
    //     {
    //       image: "/img/shoe-wipe.jpeg",
    //     },
    //   ],
    //   volumn: "200ml",
    //   list: [
    //     {
    //       menu: "DETAILS",
    //       details: [
    //         "Colloidal Zinc Effective for Shoes",
    //         "Kills 99.9% of Germs and Bacteria on Shoes",
    //         "Strong Deodorization within 30 Minutes",
    //         "7 Days of Long-Lasting Anti-Bacterial Protection ",
    //         "Nano-Colloidal Platinum for Skin Moisturization",
    //         "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
    //         "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
    //         "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
    //         "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
    //       ],
    //     },
    //     {
    //       menu: "INGREDIENTS",
    //       details: [
    //         "100% Non Alcohol",
    //         "Free of Ethanol, Benzalkonium, and Isopropanol",
    //       ],
    //     },
    //     {
    //       menu: "CUSTOMER'S BENEFIT",
    //       details: [
    //         "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
    //       ],
    //     },
    //     {
    //       menu: "ENVIRONMENT",
    //       details: ["No Harmful Toxins and Chemicals"],
    //     },
    //     {
    //       menu: "CERTIFICATION",
    //       details: ["FDA Medical Class 1 (Registered No.3021006214)"],
    //     },
    //     { menu: "LOCATION", details: ["Made in Korea"] },
    //   ],
    //   icon: ["plant", "no-bacteria", "korea"],
    // },

    // {
    //   group: "shoe",
    //   productId: "prod_LQUNCp56fHwxb6",
    //   title: "Shoe Cleaner Spray",
    //   subtitle: "Kills 99.9% of Germs and Bacteria on Shoes",
    //   price_US: 12.99,
    //   price_KO: 5000,
    //   linkTo: "shoe-spray",
    //   img: "/img/shoe-spray.jpeg",
    //   imgs: [
    //     {
    //       image: "/img/shoe-spray.jpeg",
    //     },
    //     {
    //       image: "/img/shoe-spray.jpeg",
    //     },
    //   ],
    //   volumn: "200ml",
    //   list: [
    //     {
    //       menu: "DETAILS",
    //       details: [
    //         "Colloidal Zinc Effective for Shoes",
    //         "Kills 99.9% of Germs and Bacteria on Shoes",
    //         "Strong Deodorization within 30 Minutes",
    //         "7 Days of Long-Lasting Anti-Bacterial Protection ",
    //         "Nano-Colloidal Platinum for Skin Moisturization",
    //         "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
    //         "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
    //         "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
    //         "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
    //       ],
    //     },
    //     {
    //       menu: "INGREDIENTS",
    //       details: [
    //         "100% Non Alcohol",
    //         "Free of Ethanol, Benzalkonium, and Isopropanol",
    //       ],
    //     },
    //     {
    //       menu: "CUSTOMER'S BENEFIT",
    //       details: [
    //         "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
    //       ],
    //     },
    //     {
    //       menu: "ENVIRONMENT",
    //       details: ["No Harmful Toxins and Chemicals"],
    //     },
    //     {
    //       menu: "CERTIFICATION",
    //       details: ["FDA Medical Class 1 (Registered No.3021006214)"],
    //     },
    //     { menu: "LOCATION", details: ["Made in Korea"] },
    //   ],
    //   icon: ["plant", "no-bacteria", "korea"],
    // },

    // {
    //   group: "shoe",
    //   productId: "prod_LQUTfKii0FBCxG",
    //   title: "Shoe Nano Coating Spray",
    //   subtitle: "Kills 99.9% of Germs and Bacteria on Shoes",
    //   price_US: 12.99,
    //   price_KO: 4000,
    //   linkTo: "shoe-coating-spray",
    //   img: "/img/shoe-spray.jpeg",
    //   imgs: [
    //     {
    //       image: "/img/shoe-spray.jpeg",
    //     },
    //     {
    //       image: "/img/shoe-spray.jpeg",
    //     },
    //   ],
    //   volumn: "200ml",
    //   list: [
    //     {
    //       menu: "DETAILS",
    //       details: [
    //         "Colloidal Zinc Effective for Shoes",
    //         "Kills 99.9% of Germs and Bacteria on Shoes",
    //         "Strong Deodorization within 30 Minutes",
    //         "7 Days of Long-Lasting Anti-Bacterial Protection ",
    //         "Nano-Colloidal Platinum for Skin Moisturization",
    //         "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
    //         "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
    //         "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
    //         "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
    //       ],
    //     },
    //     {
    //       menu: "INGREDIENTS",
    //       details: [
    //         "100% Non Alcohol",
    //         "Free of Ethanol, Benzalkonium, and Isopropanol",
    //       ],
    //     },
    //     {
    //       menu: "CUSTOMER'S BENEFIT",
    //       details: [
    //         "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
    //       ],
    //     },
    //     {
    //       menu: "ENVIRONMENT",
    //       details: ["No Harmful Toxins and Chemicals"],
    //     },
    //     {
    //       menu: "CERTIFICATION",
    //       details: ["FDA Medical Class 1 (Registered No.3021006214)"],
    //     },
    //     { menu: "LOCATION", details: ["Made in Korea"] },
    //   ],
    //   icon: ["plant", "no-bacteria", "korea"],
    // },

    // {
    //   group: "shoe",
    //   productId: "prod_LS8FQM6rZKa4O9",
    //   title: "Shoe Nano Coating Gel",
    //   subtitle: "Kills 99.9% of Germs and Bacteria on Shoes",
    //   price_US: 12.99,
    //   price_KO: 6000,
    //   linkTo: "shoe-coating-gel",
    //   img: "/img/coatinggel.jpeg",
    //   imgs: [
    //     {
    //       image: "/img/coatinggel.jpeg",
    //     },
    //     {
    //       image: "/img/coatinggel.jpeg",
    //     },
    //   ],
    //   volumn: "200ml",
    //   list: [
    //     {
    //       menu: "DETAILS",
    //       details: [
    //         "Colloidal Zinc Effective for Shoes",
    //         "Kills 99.9% of Germs and Bacteria on Shoes",
    //         "Strong Deodorization within 30 Minutes",
    //         "7 Days of Long-Lasting Anti-Bacterial Protection ",
    //         "Nano-Colloidal Platinum for Skin Moisturization",
    //         "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
    //         "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
    //         "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
    //         "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
    //       ],
    //     },
    //     {
    //       menu: "INGREDIENTS",
    //       details: [
    //         "100% Non Alcohol",
    //         "Free of Ethanol, Benzalkonium, and Isopropanol",
    //       ],
    //     },
    //     {
    //       menu: "CUSTOMER'S BENEFIT",
    //       details: [
    //         "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
    //       ],
    //     },
    //     {
    //       menu: "ENVIRONMENT",
    //       details: ["No Harmful Toxins and Chemicals"],
    //     },
    //     {
    //       menu: "CERTIFICATION",
    //       details: ["FDA Medical Class 1 (Registered No.3021006214)"],
    //     },
    //     { menu: "LOCATION", details: ["Made in Korea"] },
    //   ],
    //   icon: ["plant", "no-bacteria", "korea"],
    // },

    // {
    //   group: "shoe",
    //   productId: "prod_LS8HPrzBMiQqbE",
    //   title: "Shoe Anti-Baterial Deodorization Spray",
    //   subtitle: "Kills 99.9% of Germs and Bacteria on Shoes",
    //   price_US: 12.99,
    //   price_KO: 5000,
    //   linkTo: "shoe-deo-coating-spray",
    //   img: "/img/shoe-deor.jpeg",
    //   imgs: [
    //     {
    //       image: "/img/shoe-deor.jpeg",
    //     },
    //     {
    //       image: "/img/shoe-deor.jpeg",
    //     },
    //   ],
    //   volumn: "200ml",
    //   list: [
    //     {
    //       menu: "DETAILS",
    //       details: [
    //         "Colloidal Zinc Effective for Shoes",
    //         "Kills 99.9% of Germs and Bacteria on Shoes",
    //         "Strong Deodorization within 30 Minutes",
    //         "7 Days of Long-Lasting Anti-Bacterial Protection ",
    //         "Nano-Colloidal Platinum for Skin Moisturization",
    //         "Centella Asiatica Extract- Wound & Scar healing / Anti-inflammatory",
    //         "Solanum Tuberosum Pulp Extract- Antioxidant (Brightening & Soothing Effects)",
    //         "Cordyceps Militaris Extract-Immune Strengthening, Anti-inflammatory effect",
    //         "Magnolia Liliflora Flower Extract-Dermatomycosis Treatment / Reduction of Staphylococcus / blemish relief",
    //       ],
    //     },
    //     {
    //       menu: "INGREDIENTS",
    //       details: [
    //         "100% Non Alcohol",
    //         "Free of Ethanol, Benzalkonium, and Isopropanol",
    //       ],
    //     },
    //     {
    //       menu: "CUSTOMER'S BENEFIT",
    //       details: [
    //         "Effective Skincare and Anti-Bacterial Effects (The Combination of Natural Ingredients & Nano-Technology)",
    //       ],
    //     },
    //     {
    //       menu: "ENVIRONMENT",
    //       details: ["No Harmful Toxins and Chemicals"],
    //     },
    //     {
    //       menu: "CERTIFICATION",
    //       details: ["FDA Medical Class 1 (Registered No.3021006214)"],
    //     },
    //     { menu: "LOCATION", details: ["Made in Korea"] },
    //   ],
    //   icon: ["plant", "no-bacteria", "korea"],
    // },
  ];
  const value = { products, MAXIMUM_QUANTITY };

  useEffect(() => {}, []);
  return (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
  );
}
